import React, {FC} from "react"
import {FormattedMessage} from "@irati/utils/lang"
import {WellnessMedia} from "@irati/types"
import {H1, H5, Label} from "@irati/ui/src/Typography"
import mainTheme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"
import BaseSvgIcon from "@irati/ui/src/Icon/customIcons/Base"
import Badge from "@irati/ui/src/Badge"
import {RentalPlaceholderWrapper, RentalPlaceholderContent} from "./styled"
import DetailsPill from "../MediaCard/DetailsPill"

interface Props {
  media: WellnessMedia
}

const PremiumPlaceholder: FC<Props> = ({media}) => (
  <RentalPlaceholderWrapper thumbnail={media.thumbnail} marginTop={5}>
    <RentalPlaceholderContent>
      <Flex alignItems="center">
        <H5 color={mainTheme.colors.greys.white} marginRight={2}>
          <FormattedMessage id="wellness.rentalMedia.wellnessHub" />
        </H5>
        <Badge color={mainTheme.colors.primary1} uppercase weight="semibold">
          <FormattedMessage id="wellness.rentalMedia.premium" />
        </Badge>
      </Flex>
      <H1 color={mainTheme.colors.greys.white} marginTop={2} marginBottom={2}>
        {media.title}
      </H1>
      <Flex>
        <Flex alignItems="center" marginRight={3}>
          <BaseSvgIcon viewBox="0 0 30 30" width={14} height={14} fill={mainTheme.colors.greys.white} marginRight>
            <path d={media.category.svgData} />
          </BaseSvgIcon>
          <Label color={mainTheme.colors.greys.white}>{media.category.mediaLabel}</Label>
        </Flex>
        <Flex alignItems="center">
          <DetailsPill text={media.duration} type={media.type} />
        </Flex>
      </Flex>
    </RentalPlaceholderContent>
  </RentalPlaceholderWrapper>
)

export default PremiumPlaceholder
